// Module
var code = "<template> <require from=\"./page-cta.scss\"></require> <button click.trigger=\"onClick()\" appearance=\"solid\" accent=\"primary\" unelevated disabled.bind=\"disabled\"> <slot></slot> </button> </template> ";
// Exports
module.exports = code;